import React, { HTMLAttributes, ReactNode } from "react";
import classNames from "classnames";
import "./heading.scss";

type THeadingType = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";

type TStyleAsType = "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "default-highlighted";

export interface THeading extends HTMLAttributes<HTMLHeadingElement> {
    type: THeadingType;
    styleAs?: TStyleAsType;
    children: ReactNode;
    className?: string;
    onDarkBackground?: boolean;
}

export const Heading = ({
    type = "h1",
    styleAs,
    children,
    className,
    onDarkBackground = false,
    ...props
}: THeading) => {
    const HeadingTag = type;

    return (
        <HeadingTag
            className={classNames(
                `c-heading-${styleAs ?? type}`,
                { "c-heading--on-dark-bg": onDarkBackground },
                className
            )}
            {...props}
        >
            {children}
        </HeadingTag>
    );
};
